import { Phone, MapPin } from "lucide-react";
import { RESTAURANT_INFO, IMAGES } from "../data/menu";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-end overflow-hidden bg-black"
    >
      <div
        className="absolute inset-0 bg-cover"
        style={{
          backgroundImage: `url('${IMAGES.hero}')`,
          backgroundPosition: "center 70%",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/50" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />

      {/* Grain */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08] mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='1'/></svg>\")",
        }}
      />

      <div className="relative max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16 pt-32 sm:pb-24 sm:pt-40">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-orange-500" />
            <span className="text-[11px] sm:text-xs uppercase tracking-[0.35em] text-orange-400 font-semibold">
              Desde 1985 · Chihuahua
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display uppercase text-white text-6xl sm:text-7xl lg:text-8xl leading-[0.9] tracking-tighter"
          >
            Mariscos
            <br />
            <span className="text-red-600">Popeye</span>{" "}
            <span className="text-white/90">1985</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-lg sm:text-2xl text-white/80 max-w-xl leading-snug"
          >
            Directo del mar a su paladar.
          </p>

          <div className="mt-10 flex flex-wrap gap-3 sm:gap-4">
            <a
              href={`tel:+52${RESTAURANT_INFO.phone}`}
              data-testid="hero-call-button"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-sm sm:text-base uppercase tracking-widest px-6 sm:px-8 py-4 transition-all hover:-translate-y-0.5 shadow-[0_8px_0_0_rgba(127,0,0,1)] hover:shadow-[0_4px_0_0_rgba(127,0,0,1)]"
            >
              <Phone size={18} strokeWidth={2.5} />
              Llamar ahora
            </a>
            <a
              href={RESTAURANT_INFO.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-directions-button"
              className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white hover:bg-white hover:text-black font-semibold text-sm sm:text-base uppercase tracking-widest px-6 sm:px-8 py-4 transition-all"
            >
              <MapPin size={18} strokeWidth={2.5} />
              Cómo llegar
            </a>
          </div>

          <div className="mt-12 flex items-center gap-6 text-white/60 text-xs sm:text-sm uppercase tracking-widest">
            <div>
              <p className="text-orange-400 font-display text-3xl leading-none">40+</p>
              <p className="mt-1">Años de sabor</p>
            </div>
            <span className="h-10 w-px bg-white/20" />
            <div>
              <p className="text-red-500 font-display text-3xl leading-none">15</p>
              <p className="mt-1">Categorías</p>
            </div>
            <span className="h-10 w-px bg-white/20" />
            <div className="hidden sm:block">
              <p className="text-orange-400 font-display text-3xl leading-none">100%</p>
              <p className="mt-1">Fresco</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
